module.exports = __webpack_public_path__ + "img/slideshow2.6e256112.jpg";